.innerCarouselItem {
  width: 100%;
  min-width: 100%;
  min-height: 251px;
  aspect-ratio: 160 / 39;
  position: relative;
  display: flex;
  align-items: center;
  cursor: default;
}

.innerCarouselImg {
  width: 100%;
  height: 100%;
}

@media all and (--reefer-media-desktop-sm-min) {
 .innerCarouselItem {
   aspect-ratio: 149 / 36;
 }

}

